/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	RangeControl,
	ButtonGroup,
	Button,
	TabPanel,
	Dashicon,
} from '@wordpress/components';
/**
 * Internal dependencies
 */

function RangeTypographyControl(props) {
	let sizeTypes;

	if ('sizeTypes' in props) {
		sizeTypes = props.sizeTypes;
	} else {
		sizeTypes = [
			{ key: 'px', name: __('px') },
			{ key: 'em', name: __('em') },
		];
	}

	const sizeTypesControls = (
		<ButtonGroup
			className="wpsp-size-type-field"
			aria-label={__('Size Type')}
		>
			{sizeTypes.map(({ name, key }) => (
				<Button
					key={key}
					className="wpsp-size-btn"
					isSmall
					isPrimary={props.type.value === key}
					aria-pressed={props.type.value === key}
					onClick={() =>
						props.setAttributes({ [props.typeLabel]: key })
					}
				>
					{name}
				</Button>
			))}
		</ButtonGroup>
	);

	return (
		<div className="wpsp-typography-range-options">
			<TabPanel
				className="wpsp-size-type-field-tabs"
				activeClass="active-tab"
				tabs={[
					{
						name: 'desktop',
						title: <Dashicon icon="desktop" />,
						className: 'wpsp-desktop-tab wpsp-responsive-tabs',
					},
					{
						name: 'tablet',
						title: <Dashicon icon="tablet" />,
						className: 'wpsp-tablet-tab wpsp-responsive-tabs',
					},
					{
						name: 'mobile',
						title: <Dashicon icon="smartphone" />,
						className: 'wpsp-mobile-tab wpsp-responsive-tabs',
					},
				]}
			>
				{(tab) => {
					let tabout;

					if ('mobile' === tab.name) {
						tabout = (
							<>
								{sizeTypesControls}
								<RangeControl
									label={props.sizeMobileText}
									value={props.sizeMobile.value}
									onChange={(value) =>
										props.setAttributes({
											[props.sizeMobileLabel]: value,
										})
									}
									min={0}
									max={100}
									step={props.steps}
									beforeIcon="editor-textcolor"
									allowReset={true}
									initialPosition={30}
								/>
							</>
						);
					} else if ('tablet' === tab.name) {
						tabout = (
							<>
								{sizeTypesControls}
								<RangeControl
									label={props.sizeTabletText}
									value={props.sizeTablet.value}
									onChange={(value) =>
										props.setAttributes({
											[props.sizeTabletLabel]: value,
										})
									}
									min={0}
									max={100}
									step={props.steps}
									beforeIcon="editor-textcolor"
									allowReset={true}
									initialPosition={30}
								/>
							</>
						);
					} else {
						tabout = (
							<>
								{sizeTypesControls}
								<RangeControl
									label={props.sizeText}
									value={props.size.value || ''}
									onChange={(value) =>
										props.setAttributes({
											[props.sizeLabel]: value,
										})
									}
									min={0}
									max={100}
									step={props.steps}
									beforeIcon="editor-textcolor"
									allowReset={true}
									initialPosition={30}
								/>
							</>
						);
					}

					return <div>{tabout}</div>;
				}}
			</TabPanel>
		</div>
	);
}

export default RangeTypographyControl;
